import React, { useEffect } from 'react';
import './ConverterModal.css';

interface ConverterModalProps {
    isOpen: boolean;
    onClose: () => void;
    converterType: 'chanakya' | 'gujarati';
}

const ConverterModal: React.FC<ConverterModalProps> = ({ isOpen, onClose, converterType }) => {
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && isOpen) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);
            // Prevent body scroll when modal is open
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const widgetFileName = converterType === 'chanakya' 
        ? 'chanakya-converter-widget.html' 
        : 'gujarati-converter-widget.html';
    
    const converterTitle = converterType === 'chanakya' 
        ? 'Sanksrit/Hindi Converter' 
        : 'Gujarati Converter';

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="converter-modal-overlay" onClick={handleOverlayClick}>
            <div className="converter-modal-content">
                <div className="converter-modal-header">
                    <h2 className="converter-modal-title">{converterTitle}</h2>
                    <button
                        className="converter-modal-close"
                        onClick={onClose}
                        aria-label="Close converter"
                    >
                        ×
                    </button>
                </div>
                <div className="converter-modal-body">
                    <iframe
                        src={`/converters/${widgetFileName}`}
                        className="converter-iframe"
                        title={converterTitle}
                        frameBorder="0"
                    />
                </div>
            </div>
        </div>
    );
};

export default ConverterModal;

